<template>
    <div>
        <v-card class="mt-4">
            <v-toolbar elevation="0">
                <v-text-field
                        flat
                        solo
                        prepend-icon="search"
                        placeholder="Type something"
                        v-model="search"
                        hide-details
                        class="hidden-sm-and-down"
                ></v-text-field>
                <v-spacer></v-spacer>
                <v-btn class="ml-2" color="primary" @click.native="getTopupList()">
                    <v-icon dark>refresh</v-icon>Refresh
                </v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            <v-data-table
                    :headers="headers"
                    :search="search"
                    :items="topuplist"
                    class="elevation-1"
                    item-key="id"
                    :loading="loading"
            >
                <template v-slot:item.channelname="{ item }">
                    <v-row>
                        <v-img max-width="50" contain :src="logoChannel(item.channelname)"></v-img>
                        <div class="ml-2 mt-2 justify-center text-center">{{item.channelname}}</div>
                    </v-row>
                </template>
                <template v-slot:item.amount="{ item }">
                    <div class="text-right">
                        {{formatAngka(item.amount)}}
                    </div>
                </template>
            </v-data-table>
        </v-card>
    </div>
</template>

<script>
    import {mapActions, mapState} from "vuex";

    export default {
        name: "TopupChannelPage",
        data: () => ({
            search: '',
            headers: [
                {
                    text: 'id',
                    value: 'id'
                },
                {
                    text: 'ReffId',
                    value: 'reff'
                },
                {
                    text: 'channelname',
                    value: 'channelname'
                },
                {
                    text: 'Amount',
                    value: 'amount'
                },
                {
                    text: 'Status',
                    value: 'status'
                },
                {
                    text: 'Created At',
                    value: 'waktu'
                }
            ],
        }),
        mounted(){
            this.getTopupList();
        },
        computed: {
            ...mapState('TopupChannel', ['topuplist', 'dialog', 'loading']),
        },
        methods: {
            ...mapActions('TopupChannel', ['getTopupList']),
            logoChannel(channel){
                if(channel==='ALFAMART'){
                    return "https://aviana.id/images/alfamartlogo.png"
                }
                if(channel==='VA-BCA'){
                    return "https://aviana.id/images/logobca.png"
                }
                if(channel==='VA-BRI'){
                    return "https://aviana.id/images/briva.png"
                }
                if(channel==='VA-BNI'){
                    return "https://aviana.id/images/bni.png"
                }
                if(channel==='VA-MANDIRI'){
                    return "https://aviana.id/images/mandiri.png"
                }
            },
            formatAngka(angka) {
                var rev = parseInt(angka, 10).toString().split('').reverse().join('');
                var rev2 = '';
                for (var i = 0; i < rev.length; i++) {
                    rev2 += rev[i];
                    if ((i + 1) % 3 === 0 && i !== (rev.length - 1)) {
                        rev2 += '.';
                    }
                }
                return rev2.split('').reverse().join('').toString();
            }
        }
    }
</script>

<style scoped>

</style>
